import Text from '../../../Text'
import { getSelectDropdownEntityListItenInfoStylesMods } from '../../Select.utils'

import * as styles from './SelectDropdownEntityListItemContentInfoAdditionalData.module.css'

function SelectDropdownEntityListItemContentInfoAdditionalData({
  className = styles.SelectDropdownEntityListItemContentInfoAdditionalData,
  ref,
  value,
  ...restProps
}) {
  const { additionalData } = value

  const additionalDataClassName = getSelectDropdownEntityListItenInfoStylesMods(
    {
      ...restProps,
      className,
      styles,
    }
  )

  return additionalData ? (
    <Text isSecondary className={additionalDataClassName} ref={ref}>
      {additionalData}
    </Text>
  ) : null
}

export default SelectDropdownEntityListItemContentInfoAdditionalData
